// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-header h3{font-size:1.2rem;margin-bottom:0}", "",{"version":3,"sources":["webpack://./src/components/ModalView/style.scss"],"names":[],"mappings":"AACE,iBACE,gBAAA,CACA,eAAA","sourcesContent":[".modal-header {\n  h3 {\n    font-size: 1.2rem;\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
